import * as React from "react";
import { Icon } from "@chakra-ui/react";
const Internal = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#F26322", d: "M16.854 5.996v8.002l-1.981 1.14V7.145L9.92 4.284 4.965 7.146l.013 7.995L3 13.998V6.003L9.932 2zm-5.94 9.141-.988.575-.994-.568V7.146L6.955 8.29l.004 7.995L9.924 18l2.971-1.715V8.286l-1.981-1.143z" }));
const SvgMagnetoLightmode = (props) => {
  return /* @__PURE__ */ React.createElement(Icon, { as: Internal, ...props });
};
export default SvgMagnetoLightmode;
